// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getCountryListApi } from "../utils/Constants";

export const getCountryList = createAsyncThunk("getCountryList", async () => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
    };

    const response = await axios.get(ApiBaseUrl + getCountryListApi, config);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});

const GetCountryListSlice = createSlice({
  name: "getCountryListReducer",

  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearGetCountryListData: (state) => {
      state.data = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getCountryList.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearDataCreateCountry } = GetCountryListSlice.actions;
export default GetCountryListSlice.reducer;
